import React from "react";
import * as chakra from "@chakra-ui/react";
import logoShortCourses from "../imgs/logoCourses.png";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
/*
branches:
Hallam
Bendigo
Sunshine
Ballarat
Dandenong
Carrum Downs
Sale
Ridetek*/

import io from "socket.io-client";
import { objCourse } from "../objs.js";

class WindowCourseCalendar extends React.Component {
  state = {
    lstShortCourses: [],
    loadedData: [],
    lstMapCourses: new Map(),
    lstCoureObjs: [],
    lstCampusMap: new Map(),
    lstCampus: [],
    selectedCourse: "Order Picker Licence",
    selectedCampus: "Hallam",
    lstMonths: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    blockedCampus: ["Ridetek"],
    allowedCourses: [
      "Forklift Licence",
      "Order Picker Licence",
      "EWP Licence",
      "Chain of Responsibility",
      "TLIF0005 Basic Fatigue",
      "TLIF0006 FM Scheduler",
      "CI Card",
      "Dangerous Goods",
      "Traffic Management",
      "Traffic Control",
    ],
  };
  componentDidMount() {
    const { allowedCourses } = this.state;
    this.loadSocket();
    this.handleChangeCourse = this.handleChangeCourse.bind(this);
    this.handleChangeCampus = this.handleChangeCampus.bind(this);

    const queryParams = new URLSearchParams(window.location.search);
    const course = queryParams.get("course");
    if (allowedCourses.includes(course)) {
      this.setState({ selectedCourse: course });
    }
  }

  async loadSocket() {
    var ioLocation = "https://tdtplanner.com";
    //var ioLocation = "localhost:18123";
    var chatSocket = io.connect(ioLocation);

    chatSocket.on("load", (data) => {
      //console.log(data);
      this.sortData(data);
    });

    const res = await axios.get("https://geolocation-db.com/json/");
    var jData = JSON.stringify(res.data);
    chatSocket.emit("publicData", jData);
  }

  sortData(data) {
    var j = JSON.parse(data);
    var lst = [];
    var lstObjs = [];
    var lstMap = new Map();

    var lstMapCampus = new Map();
    var lstCampus = [];

    var data = j["lstCourses"];
    for (var d in data) {
      console.log(data[d]["campusid"], data[d]["campus"]);
      //console.log(data[d]["program_id"]);
      lstMap.set(data[d]["courseid"], data[d]["coursename"]);
      lstMapCampus.set(data[d]["campusid"], data[d]["campus"]);

      var obj = new objCourse(
        data[d]["campusid"],
        data[d]["courseid"],
        data[d]["intakeid"],
        data[d]["start"],
        data[d]["end"],
        data[d]["enrolled"],
        data[d]["capacity"]
      );
      obj.coursename = data[d]["coursename"];
      obj.campusid = data[d]["campusid"];
      obj.campus = data[d]["campus"];
      lstObjs.push(obj);
    }

    //["Dangerous Goods", 8],
    for (const [key, value] of lstMap.entries()) {
      lst.push([value, key]);
    }

    for (const [key, value] of lstMapCampus.entries()) {
      lstCampus.push([value, key]);
    }
    //console.log(lst);
    console.log(lstCampus);
    this.setState({
      loadedData: j,
      lstMapCourses: lstMap,
      lstShortCourses: lst,
      lstCoureObjs: lstObjs,
      lstCampusMap: lstMapCampus,
      lstCampus: lstCampus,
    });
  }

  createAvailableCourses() {
    const { lstCoureObjs, selectedCourse, selectedCampus, lstMonths } =
      this.state;
    //console.log(selectedCourse);
    var courses = <div>waiting for data</div>;

    var lstFilter = [];
    for (var c in lstCoureObjs) {
      if (
        lstCoureObjs[c].coursename == selectedCourse &&
        lstCoureObjs[c].enrolled != lstCoureObjs[c].capacity &&
        selectedCampus == lstCoureObjs[c].campus
      ) {
        lstFilter.push(lstCoureObjs[c]);
      }
    }

    var months = [];

    for (var m in lstMonths) {
      var monthNum = Number(m) + 1;
      var tmp = [];
      var count = 0;
      for (var f in lstFilter) {
        if (lstFilter[f].startMonth == monthNum) {
          count += 1;
          tmp.push(lstFilter[f]);
        }
      }
      if (count > 0) {
        months.push(
          <chakra.Box w="100%" p={4}>
            <chakra.Text fontSize="6xl">{lstMonths[m]}</chakra.Text>
          </chakra.Box>
        );
        try {
          var tmpcourses = tmp.map((item) => (
            <div key={uuidv4()} className="uiq_tr fadeIn menuItems">
              <div className="uiq_item fadeIn">{item.coursename}</div>
              <div className="uiq_item fadeIn">id: {item.intakeid}</div>
              <div className="uiq_item fadeIn">Start date {item.startDate}</div>
              <div className="uiq_item fadeIn">End date {item.endDate}</div>
              <div className="uiq_item fadeIn">
                {item.capacity - item.enrolled} spots left
              </div>
            </div>
          ));
          months.push(tmpcourses);
        } catch (e) {
          //console.log(e);
        }
      }
    }

    return months;
  }

  /* */

  handleChangeCourse(event) {
    //console.log(event.target.value);
    this.setState({ selectedCourse: event.target.value });
  }

  handleChangeCampus(event) {
    //console.log(event.target.value);
    this.setState({ selectedCampus: event.target.value });
  }

  generateCourseOptions() {
    const { allowedCourses, lstShortCourses } = this.state;
    var approved = [];
    for (var c in lstShortCourses) {
      if (allowedCourses.includes(lstShortCourses[c][0])) {
        approved.push(lstShortCourses[c]);
      }
    }
    const listItems = approved.map((item) => (
      <option key={uuidv4()} value={item[0]}>
        {item[0]}
      </option>
    ));
    return listItems;
  }

  generateCampusOptions() {
    const { blockedCampus, lstCampus } = this.state;
    var approved = [];

    for (var c in lstCampus) {
      console.log(lstCampus[c]);
      if (!blockedCampus.includes(lstCampus[c][0])) {
        approved.push(lstCampus[c]);
      }
    }

    const listCampusItems = approved.map((item) => (
      <option key={uuidv4()} value={item[0]}>
        {item[0]}
      </option>
    ));
    return listCampusItems;
  }

  render() {
    //console.log(this.getCourseName(119));
    const {
      lstShortCourses,
      loadedData,
      lstCampus,
      selectedCourse,
      selectedCampus,
    } = this.state;
    //console.log(loadedData);
    var courses = this.createAvailableCourses();

    var listItems = this.generateCourseOptions();
    var listCampusItems = this.generateCampusOptions();
    /*

    <chakra.GridItem rowSpan={19} colSpan={1}>
    <chakra.Stack spacing={2} width="200px">
      {listItems}
    </chakra.Stack>
  </chakra.GridItem>*/

    return (
      <div className="window">
        <chakra.Center>
          <chakra.Text fontSize="2xl">
            The below information provides course availability. To book this
            course, please call us on <a href="tel:1800350320">1800 350 320</a>
          </chakra.Text>
        </chakra.Center>
        <chakra.Grid
          h="100vh"
          templateRows="repeat(20, 1fr)"
          templateColumns="repeat(10, 1fr)"
          gap={1}
          className="fadeIn"
        >
          <chakra.GridItem colSpan={1} rowSpan={1}>
            <chakra.Center h="50px">
              <chakra.Image
                width="100px"
                src={logoShortCourses}
                alt="logo short courses"
              />
            </chakra.Center>
          </chakra.GridItem>

          <chakra.GridItem colSpan={9} rowSpan={1}>
            <chakra.Select
              value={this.state.selectedCampus}
              onChange={this.handleChangeCampus}
              size="lg"
              variant="flushed"
            >
              {listCampusItems}
            </chakra.Select>
          </chakra.GridItem>

          <chakra.GridItem colSpan={1} rowSpan={1}>
            <chakra.Center h="50px">
              <chakra.Text>Courses:</chakra.Text>
            </chakra.Center>
          </chakra.GridItem>
          <chakra.GridItem colSpan={9} rowSpan={1}>
            <chakra.Select
              value={this.state.selectedCourse}
              onChange={this.handleChangeCourse}
              size="lg"
              variant="flushed"
            >
              {listItems}
            </chakra.Select>
          </chakra.GridItem>

          <chakra.GridItem colSpan={10} rowSpan={18}>
            <div className="lstCourses">
              <div className="uiq_tbl_same_bg">{courses}</div>
            </div>
          </chakra.GridItem>
        </chakra.Grid>
      </div>
    );
  }
}
/**/
export default WindowCourseCalendar;
